import Text from "components/common/Text/Text";
import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  className?: string;
  pointsBalance?: number;
}

const HeaderSection = styled(({ className, pointsBalance }: IProps) => (
  <header className={className}>
    <Text h3 bold fullWidth center>
      {pointsBalance}
    </Text>
    <label>Your Existing Points</label>
  </header>
))`
  width: 100%;
  padding: 2rem;
  text-align: center;
    background-color: ${theme.color.secondary};
    border-bottom: 1px solid ${theme.color.primary};
    border-top-right-radius: ${theme.global.radius};
    border-top-left-radius: ${theme.global.radius};
    h1 {
        color: ${theme.color.primary};
    }
    label {
      font-size: 14px;
      text-transform: uppercase;
      font-family: ${theme.fontFamily.bold}
      color: ${theme.color.primary};
    }
`;

export default HeaderSection;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/ChooseRewards/Cart/HeaderSection.tsx